export default "__VITE_ASSET__enbgmTO8__"